export default __webpack_public_path__ + "51a088194592f667cff32eb3eef39af8.svg";